import { render, staticRenderFns } from "./DropdownButton.vue?vue&type=template&id=0d0f09ba&scoped=true&"
import script from "./DropdownButton.vue?vue&type=script&lang=js&"
export * from "./DropdownButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d0f09ba",
  null
  
)

export default component.exports